var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form-item",
    { attrs: { label: _vm.label, "label-width": _vm.isZh ? "" : "150px" } },
    [
      _vm.isJobNo
        ? _c("cargo-multi-line-text-popover", {
            staticStyle: { display: "block", width: "230px" },
            attrs: {
              "show-popover": true,
              value: _vm.item.value,
              "visible-arrow": false
            },
            on: {
              "update:value": function($event) {
                return _vm.$set(_vm.item, "value", $event)
              }
            }
          })
        : _vm.isMbl
        ? _c("cargo-multi-line-text-popover", {
            staticStyle: { display: "block", width: "230px" },
            attrs: {
              "show-popover": true,
              value: _vm.item.value,
              "visible-arrow": false
            },
            on: {
              "update:value": function($event) {
                return _vm.$set(_vm.item, "value", $event)
              }
            }
          })
        : _vm.item.dataType === 1
        ? _c(
            "div",
            { staticStyle: { display: "flex", width: "230px" } },
            [
              _vm.displayCurrency
                ? [
                    _c("cargo-advance-select", {
                      staticStyle: { width: "230px" },
                      attrs: {
                        no: "1",
                        "select-type": _vm.TYPE_NAMES.basic_data_Currency,
                        "allow-create": !_vm.item.isMore,
                        filterable: "",
                        "filter-type": "global",
                        multiple: _vm.item.isMore,
                        "default-value": _vm.defaultValue,
                        "default-multiple-value": _vm.defaultMultipleValue,
                        "show-custom-label-in-option": false,
                        "use-tag-name-at-multiple": true,
                        headers: [
                          _vm.$t("baseInfo.basicData.currency.code"),
                          _vm.$t("baseInfo.basicData.currency.name"),
                          _vm.$t("baseInfo.basicData.currency.localName")
                        ],
                        fields: ["code", "name", "localName"],
                        "filter-field-names": ["code", "name", "localName"]
                      },
                      on: { parentCallBack: _vm.onParentCallBack }
                    })
                  ]
                : [
                    _c("cargo-advance-select", {
                      staticStyle: { width: "230px" },
                      attrs: {
                        no: "1",
                        cache: false,
                        "allow-create": !_vm.item.isMore,
                        filterable: "",
                        "filter-type": "global",
                        multiple: _vm.item.isMore,
                        "default-value": _vm.defaultValue,
                        "default-multiple-value": _vm.defaultMultipleValue,
                        "tag-value": _vm.tagName,
                        "tag-name": _vm.tagName,
                        "filter-tag-names": [_vm.tagName],
                        "static-options": _vm.options
                      },
                      on: { parentCallBack: _vm.onParentCallBack }
                    }),
                    _vm.displayByLevel
                      ? [
                          _c(
                            "el-button",
                            {
                              staticStyle: {
                                "margin-left": "3px",
                                width: "30px",
                                "min-width": "30px"
                              },
                              attrs: { type: "primary" },
                              on: { click: _vm.showBranchSelectDialog }
                            },
                            [_vm._v("...")]
                          ),
                          _c("branch-select-dialog", {
                            attrs: {
                              visible: _vm.branchSelectDialog.visible,
                              value: _vm.branchSelectDialog.value,
                              "office-list": _vm.options
                            },
                            on: {
                              "update:visible": function($event) {
                                return _vm.$set(
                                  _vm.branchSelectDialog,
                                  "visible",
                                  $event
                                )
                              },
                              callback: _vm.branchSelectDialog.callback
                            }
                          })
                        ]
                      : _vm._e()
                  ]
            ],
            2
          )
        : _vm.item.dataType === 5
        ? [
            _vm.item.isRange
              ? _c(
                  "div",
                  { staticStyle: { display: "flex", width: "230px" } },
                  [
                    _c("el-date-picker", {
                      staticStyle: { width: "110px", "margin-right": "5px" },
                      attrs: {
                        no: "2",
                        type: "date",
                        "value-format": "yyyy-MM-dd"
                      },
                      on: { change: _vm.dateRangeChange },
                      model: {
                        value: _vm.dateStart,
                        callback: function($$v) {
                          _vm.dateStart = $$v
                        },
                        expression: "dateStart"
                      }
                    }),
                    _vm._v(" - "),
                    _c("el-date-picker", {
                      staticStyle: { width: "110px", "margin-left": "5px" },
                      attrs: {
                        no: "3",
                        type: "date",
                        "value-format": "yyyy-MM-dd"
                      },
                      on: { change: _vm.dateRangeChange },
                      model: {
                        value: _vm.dateEnd,
                        callback: function($$v) {
                          _vm.dateEnd = $$v
                        },
                        expression: "dateEnd"
                      }
                    })
                  ],
                  1
                )
              : _c("el-date-picker", {
                  staticStyle: { width: "230px" },
                  attrs: {
                    no: "4",
                    value: _vm.innerDate,
                    type: "date",
                    "value-format": "yyyy-MM-dd"
                  },
                  on: {
                    input: function(val) {
                      _vm.item.value = _vm.innerDate = val || ""
                    }
                  }
                })
          ]
        : _vm.item.dataType === 4
        ? _c(
            "el-radio-group",
            {
              staticStyle: { width: "230px" },
              attrs: { no: "5" },
              model: {
                value: _vm.item.value,
                callback: function($$v) {
                  _vm.$set(_vm.item, "value", $$v)
                },
                expression: "item.value"
              }
            },
            [
              _c("el-radio", { attrs: { label: "true" } }, [
                _vm._v(_vm._s(_vm.$t("Message.Yes")))
              ]),
              _c("el-radio", { attrs: { label: "false" } }, [
                _vm._v(_vm._s(_vm.$t("Message.No")))
              ]),
              _c("el-radio", { attrs: { label: "" } }, [
                _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_All")))
              ])
            ],
            1
          )
        : _c("el-input", {
            staticStyle: { width: "230px" },
            attrs: { no: "6" },
            model: {
              value: _vm.item.value,
              callback: function($$v) {
                _vm.$set(_vm.item, "value", $$v)
              },
              expression: "item.value"
            }
          })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }